module.exports = __webpack_public_path__ + "static/img/nav2.5fc7943.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution1/nav2.png
// module id = kPgb
// module chunks = 12